import * as React from 'react';
import './pages.module.scss';

type ContainerProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  id?: string;
  className?: string;
  styleName?: string;
};
export const Page = ({ children, id, className }: ContainerProps) => (
  <div styleName="page" className={className} id={id}>
    {children}
  </div>
);
export const PageBody = ({ children, className = undefined }: ContainerProps) => (
  <div styleName="page-body" className={className}>
    {children}
  </div>
);
